import Slice, { geometriesSlice } from './geometries.slice';
import Voxel, { geometriesVoxel } from './geometries.voxel';

export {
  Slice as SliceGeometry,
  geometriesSlice as sliceGeometryFactory,
  Voxel as VoxelGeometry,
  geometriesVoxel as voxelGeometryFactory,
};
